<template>
  <div>
    <validation-observer ref="form">
      <b-form @submit.prevent="save">
        <div class="vx-row">
          <div class="vx-col w-full">
            <b-form-group
              label="Tipo de Endereço"
              label-for="address_type_id">
              <validation-provider
                #default="{ errors }"
                :name="$t('address.type')"
                rules="required">
                <v-select
                  id="address_type_id"
                  v-model="address.addressType"
                  :options="addressTypeList"
                  label="name"
                  class="required-select">
                  <div slot="no-options">Nenhum registro encontrado!</div>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/5 w-full">
            <b-form-group
              label="CEP"
              label-for="postal_code">
              <validation-provider
                #default="{ errors }"
                :name="$t('address.postal_code')">
                <b-form-input
                  id="postal_code"
                  v-model="address.postalCode"
                  :state="errors.length > 0 ? false:null"
                  name="postal_code"
                  v-mask="'##.###-###'"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </div>
          <div class="vx-col sm:w-3/5 w-full">
            <b-form-group
              label="Logradouro"
              label-for="street_name">
              <validation-provider
                #default="{ errors }"
                :name="$t('address.street_name')"
                rules="required">
                <b-form-input
                  id="street_name"
                  v-model="address.streetName"
                  :state="errors.length > 0 ? false:null"
                  name="street_name"
                  class="required"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </div>
          <div class="vx-col sm:w-1/5 w-full">
            <b-form-group
              label="Número"
              label-for="street_number">
              <validation-provider
                #default="{ errors }"
                :name="$t('address.street_number')">
                <b-form-input
                  id="street_number"
                  v-model="address.streetNumber"
                  :state="errors.length > 0 ? false:null"
                  name="street_number"
                  type="number"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full">
            <b-form-group
              label="Bairro"
              label-for="district_name">
              <validation-provider
                #default="{ errors }"
                :name="$t('address.district_name')">
                <b-form-input
                  id="district_name"
                  v-model="address.districtName"
                  :state="errors.length > 0 ? false:null"
                  name="district_name"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <b-form-group
              label="Estado"
              label-for="federation_unit">
              <validation-provider
                #default="{ errors }"
                :name="$t('address.federation_unit')"
                rules="required">
                <v-select
                  class="required-select"
                  v-model="address.federationUnit"
                  :options="federationUnitList"
                  label="name"
                  @input="selectFederationUnit">
                  <div slot="no-options">Nenhum registro encontrado!</div>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <b-form-group
              label="Cidade"
              label-for="city_id">
              <validation-provider
                #default="{ errors }"
                :name="$t('address.city')"
                rules="required">
                <v-select
                  id="city_id"
                  class="required-select"
                  :options="cityList"
                  label="name"
                  v-model="address.city"
                  :disabled="!showCityList">
                  <div slot="no-options">Nenhum registro encontrado!</div>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>
        <!-- Localização Geográfica -->
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full">
            <b-form-group
              :label="$t('address.latitude')"
              label-for="latitude">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('address.latitude')">
                  <b-form-input
                    id="latitude"
                    v-model="address.address_geo.latitude"
                    :state="errors.length > 0 ? false:null"
                    name="latitude"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <b-form-group
              :label="$t('address.longitude')"
              label-for="longitude">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('address.longitude')">
                  <b-form-input
                    id="longitude"
                    v-model="address.address_geo.longitude"
                    :state="errors.length > 0 ? false:null"
                    name="longitude"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
          </div>
        </div>
        <!-- Endereço principal -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <b-form-checkbox v-model="address.head" class="float-right">Endereço principal</b-form-checkbox>
          </div>
        </div>
        <div class="vx-row mt-2">
          <div class="vx-col w-full">
            <b-button
              v-if="editMode"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-secondary"
              @click="cancelEdit"
              class="float-right ">
              Limpar
            </b-button>

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              :class="['float-right', {'mr-2': editMode}]"
              :disabled="!validateForm">
              {{this.editMode ? 'Alterar' : 'Adicionar'}}
            </b-button>
          </div>
        </div>
      </b-form>
    </validation-observer>

    <div class="vx-row mt-4 mb-10">
      <div class="vx-col w-full">
        <vs-table :data="addressList" no-data-text="Nenhum registro encontrado">
          <template slot="thead">
            <vs-th>Tipo</vs-th>
            <vs-th>CEP</vs-th>
            <vs-th>Logradouro</vs-th>
            <vs-th>Número</vs-th>
            <vs-th>Bairro</vs-th>
            <vs-th>Estado</vs-th>
            <vs-th>Cidade</vs-th>
            <vs-th>Principal</vs-th>
            <vs-th>Ação</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{_.get(tr, 'address_type.name')}}</vs-td>
              <vs-td>{{data[indextr].postal_code}}</vs-td>
              <vs-td>{{data[indextr].street_name}}</vs-td>
              <vs-td>{{data[indextr].street_number}}</vs-td>
              <vs-td>{{data[indextr].district_name}}</vs-td>
              <vs-td>{{_.get(tr, 'city.federation_unit.name')}}</vs-td>
              <vs-td>{{_.get(tr, 'city.name')}}</vs-td>
              <vs-td>
                <span v-if="data[indextr].pivot.head">Sim</span>
                <span v-else>Não</span>
              </vs-td>
              <vs-td>
                <div class="flex flex-row gap-2">
                  <feather-icon
                    icon="EditIcon"
                    title="Editar"
                    style="cursor: pointer;"
                    class="h-5 w-5 mr-1 stroke-current text-warning"
                    @click="edit(data[indextr])"/>
                  <feather-icon
                    icon="Trash2Icon"
                    title="Excluir"
                    style="cursor: pointer;"
                    class="h-5 w-5 mr-1 stroke-current text-danger"
                    @click="destroy(data[indextr])"/>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BForm, BButton, BFormInput, BFormGroup, BFormCheckbox } from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'

import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'
import Constants from '../../../../util/Constants'

export default {
  directives: {
    Ripple,
  },
  components: {
    Datepicker,
    vSelect,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    people_id: {
      type: Number,
      default: null
    },
    services: {
      type: Object,
      default: null
    },
  },
  data: () => ({
    parentEntity: null,
    addressList: [],
    cityList: [],
    federationUnitList: [],
    addressTypeList: [],
    address: {
      id: null,
      pivotId: null,
      federationUnit: null,
      postalCode: null,
      addressType: null,
      streetName: null,
      streetNumber: null,
      districtName: null,
      city: null,
      head: false,
      address_geo: {
        id: null,
        latitude: null,
        longitude: null,
      }
    },
    editMode: false,
    // validation rules
    required,
  }),
  computed: {
    validateForm() {
      return (
        !this.isEmpty(this.address.addressType) &&
        !this.isEmpty(this.address.streetName) &&
        !this.isEmpty(this.address.city)
      )
    },
    showCityList() {
      return this.cityList.length > 0
    }
  },
  watch: {},
  methods: {
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.clearErrors(this.$refs.form)
          this.$vs.loading()

          const params = {
            people_id: this.people_id,
            postal_code: this.address.postalCode? this.clearDashDots(this.address.postalCode).replace('-', ''): null,
            street_name: this.address.streetName,
            street_number: this.address.streetNumber,
            district_name: this.address.districtName,
            address_type_id: this.address.addressType.id,
            city_id: this.address.city.id,
            head: this.address.head,
            address_geo :{
              id: this.address.address_geo.id,
              latitude: this.address.address_geo.latitude,
              longitude: this.address.address_geo.longitude,
            }
          }

          if (this.editMode) {
            params['id'] = this.address.id
          }

          this.services.addressService.createOrUpdate(params).then(
            data => {
              this.$vs.loading.close()
              this.editMode = false
              this.clearFields()
              this.loadData()
              this.notifySuccess(this.$vs)
            },
            error => {
              this.$vs.loading.close()
              this.showErrors(this.$refs.form, error)
            }
          )
        }
      })

    },
    destroy(address) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.acceptDestroy(address)
        }
      })
    },
    acceptDestroy(address) {
      this.$vs.loading()
      this.services.addressService.destroy({
          id: address.id
        }).then(
          data => {
            this.$vs.loading.close()
            this.addressList = this.addressList.filter(element => {
              return element.id !== address.id
            })
            this.notifySuccess(this.$vs)
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    selectFederationUnit(federationUnit) {
      this.address.city = null
      this.cityList = []
      if (federationUnit) {
        this.$vs.loading()
        this.services.federationUnitService.findAllCitiesByFederationUnity(federationUnit.id).then(
            data => {
              this.cityList = data
              this.$vs.loading.close()
            },
            error => {this.$vs.loading.close()}
          )
      }
    },
    edit(address) {
      this.editMode = true
      this.address.id = address.id
      this.address.pivotId = address.pivot.id
      this.address.addressType = address.address_type
      this.address.postalCode = address.postal_code
      this.address.postalCode = address.postal_code
      this.address.streetName = address.street_name
      this.address.streetNumber = address.street_number
      this.address.districtName = address.district_name
      this.address.head = address.pivot.head
      this.selectFederationUnit(address.city.federation_unit)
      this.address.city = address.city
      this.address.federationUnit = address.city.federation_unit
      this.address.address_geo = address.address_geo ? address.address_geo : {
        id: null,
        latitude: null,
        longitude: null,
      }
    },
    cancelEdit() {
      this.editMode = false
      this.clearFields()
    },
    clearFields() {
      this.address.addressType = null
      this.address.postalCode = null
      this.address.postalCode = null
      this.address.streetName = null
      this.address.streetNumber = null
      this.address.districtName = null
      this.address.city = null
      this.address.federationUnit = null
      this.address.head = false
      this.address.address_geo = {
        id: null,
        latitude: null,
        longitude: null,
      }
    },
    addressQuantity() {
      return this.addressList.length
    },
    loadData() {
      this.services.addressService.getAllByPeople(this.people_id).then(
        response => {
          this.addressList = Array.from(response)
        },
        error => {this.$vs.loading.close()}
      ).finally(() => {this.$vs.loading.close()})
    }
  },
  beforeMount() {},
  beforeDestroy() {

  },
  mounted() {
    this.loadData()

    this.services.addressTypeService.all().then(
      data => {
        this.addressTypeList = data
        this.$vs.loading.close()
      },error => {this.$vs.loading.close()}
    )

    this.services.federationUnitService.all().then(
      data => {
        this.federationUnitList = data
        this.$vs.loading.close()
      },error => {this.$vs.loading.close()}
    )
  }
}
</script>
